/**
 * 直播时间轴测试：调用后端 getview_test，由服务端按 test_seq 推进 current_minute
 *
 * 开启：仅 URL ?mock_live=1（不用 localStorage 自动开启，避免误进测试模式）
 * 关闭：?mock_live=0 会清除 localStorage tyq_mock_live
 * 调试：?debug=1 或 localStorage tyq_timeline_debug=1
 *
 * 参数（由 viewdata 拼 URL）：
 *   test_seq=1,2,3…     第几次请求（缘左移 / 自动5s 时 +1）
 *   test_entry_min=18   首次响应返回，之后每次原样回传
 */
import { timelineDebug } from './timelineDebug.js';

const LS_MOCK = 'tyq_mock_live';
const API_BASE = 'https://api.windata.top';

export function isMockLiveEnabled() {
  if (typeof window === 'undefined') return false;
  const q = new URLSearchParams(window.location.search);
  const urlVal = q.get('mock_live');
  if (urlVal === '1') {
    try { window.localStorage?.setItem(LS_MOCK, '1'); } catch (e) { /* ignore */ }
    return true;
  }
  if (urlVal === '0') {
    try { window.localStorage?.removeItem(LS_MOCK); } catch (e) { /* ignore */ }
    return false;
  }
  // 不再因 localStorage 残留而自动进入测试 API
  return false;
}

/** 清除残留的测试模式标记（正常访问时调用） */
export function clearStaleMockLiveFlag() {
  if (typeof window === 'undefined') return;
  if (isMockLiveEnabled()) return;
  try {
    if (window.localStorage?.getItem(LS_MOCK) === '1') {
      window.localStorage.removeItem(LS_MOCK);
      console.info('[tyq] 已清除残留的 tyq_mock_live，请用 ?mock_live=1 开启测试直播');
    }
  } catch (e) { /* ignore */ }
}

export function getMockLiveAutoMs() {
  const q = new URLSearchParams(window.location.search);
  const raw = q.get('mock_live_auto_ms');
  const n = raw != null ? Number(raw) : 0;
  return Number.isFinite(n) && n >= 3000 ? n : 0;
}

/** 新场次 / 切场：重置序号与 entry */
export function createTestLiveSession() {
  return {
    seq: 0,
    entryMin: null,
  };
}

/**
 * @param {string} raceId
 * @param {{ seq: number, entryMin: number|null }} session
 * @param {{ advance?: boolean }} opts advance=true 时 seq+1（缘左移、自动 tick）
 */
export function buildTestLiveGetviewUrl(raceId, session, opts = {}) {
  const rid = String(raceId || '');
  if (!rid) return `${API_BASE}/getview?race_id=`;
  if (opts.advance) {
    session.seq = Math.max(1, (session.seq || 0) + 1);
  } else if (!session.seq) {
    session.seq = 1;
  }
  const params = new URLSearchParams({
    race_id: rid,
    test_seq: String(session.seq),
  });
  if (session.entryMin != null && !Number.isNaN(Number(session.entryMin))) {
    params.set('test_entry_min', String(session.entryMin));
  }
  return `${API_BASE}/getview_test?${params.toString()}`;
}

/** 首次 getview_test 响应：保存 test_entry_min 供后续请求回传 */
export function absorbTestLiveResponse(session, payload) {
  if (!payload || payload.code === -1) return session;
  if (payload.test_entry_min != null && !Number.isNaN(Number(payload.test_entry_min))) {
    session.entryMin = Number(payload.test_entry_min);
  }
  if (payload.test_seq != null) {
    session.seq = Number(payload.test_seq);
  }
  return session;
}

export function printMockLiveHint() {
  if (!isMockLiveEnabled() || typeof window === 'undefined') return;
  console.info(
    '[tyq] 测试直播 API 已开启（getview_test）\n'
    + '  首次 test_seq=1，服务端随机 entry 15~20\n'
    + '  缘左移/自动5s：test_seq+1，带上 test_entry_min\n'
    + '  refresh() — 同 seq 重拉\n'
    + '  advance() — seq+1 再拉\n'
    + '  snapLive() — 滑块贴 current_minute\n'
    + '  startAuto(5000) / stopAuto()',
  );
}

export function logMockLive(action, detail) {
  timelineDebug(`mock_live_${action}`, detail);
}
